import React, { useRef, useState } from "react";
import "./Carousel.css";

const slides = [
  {
    image: "/images/reviews/Emeka.png",
    title: "Emeka David",
    description: "I've been learning web development with LernTutors for the past 12 weeks, and I gotta say, it's been an amazing experience! The course is super flexible and fun, and they've covered everything from JavaScript fundamentals to the latest web development tools.<br /><br />The hands-on projects have been a highlight for me. The instructor was really knowledgeable and supportive, always there to help when I get stuck. And the community is awesome -everyone is super supportive and encouraging.<br /><br />What I love about LernTutors is that they make learning feel lively and fun, not dull and dry. The lessons and projects are engaging, and I've learned so much in a short amount of time.",
    link: "https://maps.app.goo.gl/8PxxTpKyfrjyCamv5"
  },
  {
    image: "/images/reviews/Timothy.png",
    title: "Timothy",
    description: "I recently had the pleasure of learning full stack Web Development  under the umbrella of LERN TUTORS, and I must say, the experience was exceptional. From first day down the last  our tutor Mr Dickson  demonstrated a deep understanding of my needs and exceeded my expectations.<br /><br />Throughout my stay there the quality of learning was outstanding. Our tutor was being  professional, and still found a way to communicate effectively to us throughout the entire process.<br /><br />I particularly appreciated the conducive learning environment  and found it to be a valuable aspect of the service.<br /><br />If you're looking for a reliable Web Development Tutor , I highly recommend LERN TUTORS.",
    link: "https://maps.app.goo.gl/Er6AiHxB6Nobya3SA"
  },
  {
    image: "/images/reviews/Moses.png",
    title: "Huncle Moses Atteh",
    description: "My experience was the best, because outside having a teacher that is patience enough to explain complex programming languages to it simplest form and always willing to carry everyone student along(making they understand the concept the concept) i also enjoyed a Godly and a welcoming space during the course. In all LERN TUTORS is BEST PLACE TO BE.<br /><br />Speaking from experience.<br /><br />Thank you once again sir.",
    link: "https://maps.app.goo.gl/6MxgGrpJLbFgGiee9"
  },
  {
    image: "/images/reviews/Nnenna.jpg",
    title: "Eddy Nnenna",
    description: "Lern Tutors is one the best web skill development centers one can ever train at. I benefited greatly from our just concluded FULL STACK WEB DEVELOPMENT COURSE and I'm really grateful to God for the opportunity to invest in myself and  Mr. Dickson who is not just our tutor but an extraordinary one at that!, following up with his students, making sure no ones left behind and most importantly giving DETAILED LECTURE and always available to help us when faced with challenges, God bless you sir!!!<br /><br />If you're looking to take a course on Web development, LERN TUTORS is your BEST bet!!!!",
    link: "https://maps.app.goo.gl/ccrr7HhBwmGA83Yu9"
  }
];

// Clone the last and first slides for infinite looping
const carouselSlides = [
  slides[slides.length - 1],
  ...slides,
  slides[0],
];

function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const [transition, setTransition] = useState(true);

  const startX = useRef(0);

  const nextSlide = () => {
    setTransition(true);
    setCurrentSlide((prev) => prev + 1);
    setDragOffset(0);
  };

  const previousSlide = () => {
    setTransition(true);
    setCurrentSlide((prev) => prev - 1);
    setDragOffset(0);
  };

  /*
   * Start dragging
   */
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;

    setIsDragging(true);
    setTransition(false);
  };

  /*
   * Follow the finger
   */
  const handleTouchMove = (e) => {
    if (!isDragging) return;

    const currentX = e.touches[0].clientX;
    const difference = currentX - startX.current;

    setDragOffset(difference);
  };

  /*
   * Finish dragging
   */
  const handleTouchEnd = () => {
    if (!isDragging) return;

    setIsDragging(false);

    const threshold = 80;

    if (dragOffset < -threshold) {
      // Swipe left
      nextSlide();
    } else if (dragOffset > threshold) {
      // Swipe right
      previousSlide();
    } else {
      // Not enough movement — return to original position
      setTransition(true);
      setDragOffset(0);
    }
  };

  /*
   * Handle infinite looping
   */
  const handleTransitionEnd = () => {
    if (currentSlide === carouselSlides.length - 1) {
      setTransition(false);
      setCurrentSlide(1);
    }

    if (currentSlide === 0) {
      setTransition(false);
      setCurrentSlide(slides.length);
    }
  };

  /*
   * Determine which indicator should be active
   */
  const getActiveIndicator = () => {
    if (currentSlide === 0) {
      return slides.length - 1;
    }

    if (currentSlide === slides.length + 1) {
      return 0;
    }

    return currentSlide - 1;
  };

  return (
    <div
      className="carousel"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className="carousel-track"
        onTransitionEnd={handleTransitionEnd}
        style={{
          transform: `translateX(calc(-${
            currentSlide * 100
          }% + ${dragOffset}px))`,

          transition: transition
            ? "transform 0.4s ease-out"
            : "none",
        }}
      >
        {carouselSlides.map((slide, index) => (
          <div className="carousel-slide" key={index}>
            <img src={slide.image} alt={slide.title} />

            <div className="carousel-content">
              <h2>{slide.title}</h2>

              <p dangerouslySetInnerHTML={{ __html: slide.description }}></p>
              <p className="slide-link"><a href={slide.link} target="_blank" rel="noreferrer">View on Google</a></p>
            </div>
          </div>
        ))}
      </div>

      {/* Previous */}
      <button
        className="carousel-button previous"
        onClick={previousSlide}
      >
        &#10094;
      </button>

      {/* Next */}
      <button
        className="carousel-button next"
        onClick={nextSlide}
      >
        &#10095;
      </button>

      {/* Indicators */}
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={
              index === getActiveIndicator()
                ? "active"
                : ""
            }
            onClick={() => {
              setTransition(true);
              setCurrentSlide(index + 1);
              setDragOffset(0);
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default Carousel;